import React from 'react';
import { Toaster } from 'sonner';

export default function FeedbackToaster() {
  return (
    <Toaster
      position="bottom-right"
      closeButton
      expand={false}
      gap={10}
      offset={18}
      mobileOffset={12}
      toastOptions={{
        duration: 4600,
        classNames: {
          toast: 'linkit-toast',
          title: 'linkit-toast-title',
          description: 'linkit-toast-description',
          actionButton: 'linkit-toast-action',
          cancelButton: 'linkit-toast-cancel',
          closeButton: 'linkit-toast-close',
        },
      }}
    />
  );
}
